import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

import { MobilePopoverService } from './mobile-popover.service';

@NgModule({
  imports: [MatBottomSheetModule],
  providers: [MobilePopoverService]
})
export class MobilePopoverModule {}
